import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
} from '@angular/forms';
import { UserService } from '../../../../services/user.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { BikeService } from '../../../../services/bike.service';
import { PartnerService } from '../../../../services/partner.service';
import { LookupService } from '../../../../services/lookup.service';
import { AppConfig } from '../../../../app.config';
import { GearManagementService } from '../../../../services/gear-management.service';

import { OverlayPanel } from 'primeng/overlaypanel';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from '../../../../services/helpers.service';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
} from 'rxjs/operators';
import { Observable, of, switchMap } from 'rxjs';

@Component({
  selector: 'app-add-cyclist-bike',
  templateUrl: './add-cyclist-bike.component.html',
  styleUrls: ['./add-cyclist-bike.component.scss'],
})
export class AddCyclistBikeComponent implements OnInit {
  @Input() partnerId;
  @Input() user;
  @Input() selectedBike;
  @Input() messageService: MessageService;
  @Output() update = new EventEmitter();

  public UserForm: FormGroup;
  public genders: any = [
    { label: this.translate.instant('general.male'), value: 1 },
    { label: this.translate.instant('general.female'), value: 2 },
  ];
  public busy: boolean = false;
  public error: boolean = false;
  public errorMessage = '';
  public userExists: boolean = false;
  public userLinkedToPartner: boolean = false;
  public manufacturers: any = [];
  public models: any = [];
  public years: any = [];
  public DefaultUnitOfMeasure = 1;
  public cyclists: any | null = [];
  public bikes: any = [];
  public addNewBike: boolean = false;
  public bikeTypes: any = [];
  public partnerData: any = {};
  isloading = false;
  showDropdown = false;
  subscriptions: any;
  inputFocus: string = '';
  phoneResults = [];
  emailResults = [];
  firstNameResults = [];
  lastNameResults = [];
  newCustomer = false;

  constructor(
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    public userService: UserService,
    public helpersService: HelpersService,
    public cyclistService: CyclistService,
    public partnerService: PartnerService,
    public bikeService: BikeService,
    private lookupService: LookupService,
    public modal: NgbActiveModal,
    public appConfig: AppConfig,
    private translate: TranslateService,
    private gearService: GearManagementService,
  ) {
    var partnerData = helpersService.getPartnerData();
    this.partnerData = partnerData;
    this.DefaultUnitOfMeasure = partnerData.DefaultUnitOfMeasure;
  }

  ngOnInit() {
    this.setupValidation();
    this.initSearches();
    this.getBikeTypes();
  }

  setupValidation() {
    this.UserForm = this.fb.group({
      Name: new FormControl(
        this.user.Name,
        this.user && this.user.ID
          ? Validators.nullValidator
          : Validators.required,
      ),
      Surname: new FormControl(
        this.user.Surname,
        this.user && this.user.ID
          ? Validators.nullValidator
          : Validators.nullValidator,
      ),
      Email: new FormControl(
        this.user.Email,
        this.user && this.user.ID
          ? Validators.nullValidator
          : Validators.compose([Validators.nullValidator, Validators.email]),
      ),
      PhoneNumber: new FormControl(
        this.user.PhoneNumber,
        Validators.nullValidator,
      ),
      //'Email': new FormControl(this.user.ID ? this.user.Email : (this.email && this.email.indexOf("@") > -1 ? this.email : ""), Validators.compose([Validators.required, Validators.email])),
      //'PhoneNumber': new FormControl(this.user.PhoneNumber, Validators.nullValidator),

      Manufacturer: new FormControl(
        this.user.Manufacturer,
        Validators.nullValidator,
      ),
      Model: new FormControl(this.user.Model, Validators.nullValidator),
      Color: new FormControl(this.user.Color, Validators.nullValidator),
      Year: new FormControl(this.user.Year, Validators.nullValidator),
      SerialNo: new FormControl(
        this.user.SerialNo,
        this.partnerData.MandatorySerialNumber
          ? Validators.required
          : Validators.nullValidator,
      ),
      TypeID: new FormControl(this.user.TypeID || 99, Validators.required),
      PartnerID: new FormControl(this.partnerId, Validators.required),
    });

    if (this.user && this.user.ID) {
      this.busy = true;
      this.disableControls();
      this.getActiveBikes(this.user);
    }
  }

  reloadControlData() {
    this.UserForm.controls['Email'].setValue(this.user.Email);
    this.UserForm.controls['Name'].setValue(this.user.Name);
    this.UserForm.controls['Surname'].setValue(this.user.Surname);
    this.UserForm.controls['PhoneNumber'].setValue(this.user.PhoneNumber);
  }

  disableControls() {
    this.UserForm.controls['Email'].disable();
    this.UserForm.controls['Name'].disable();
    this.UserForm.controls['Surname'].disable();
    this.UserForm.controls['PhoneNumber'].disable();
  }

  enableControls() {
    this.UserForm.controls['Email'].enable();
    this.UserForm.controls['Name'].enable();
    this.UserForm.controls['Surname'].enable();
    this.UserForm.controls['PhoneNumber'].enable();
  }

  searchManufacturer(event) {
    if (this.partnerData.PartnerType === 1) {
      this.lookupService
        .getManufacturerLookup(event.query)
        .subscribe((manufacturers) => {
          this.manufacturers = manufacturers.map((item) => {
            return item.Description;
          });
        });
    }
  }

  searchModel(event) {
    if (this.partnerData.PartnerType === 1) {
      this.lookupService
        .getModelLookup(
          this.UserForm.controls['Manufacturer'].value,
          event.query,
        )
        .subscribe((models) => {
          this.models = models.map((item) => {
            return item.Description;
          });
        });
    }
  }

  searchYear(event) {
    if (this.partnerData.PartnerType === 1) {
      this.lookupService
        .getYearLookup(
          this.UserForm.controls['Manufacturer'].value,
          this.UserForm.controls['Model'].value,
          event.query,
        )
        .subscribe((years) => {
          this.years = years.map((item) => {
            return item.Description;
          });
        });
    }
  }

  searchEmail(event) {
    if (
      //this.UserForm.controls['Email'].value.length > 0 &&
      //this.UserForm.controls['Email'].value.indexOf('@') > -1
      this.UserForm.controls['Email'].value.length >= 3
    ) {
      this.user = {};
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId,
          0,
          20,
          this.UserForm.controls['Email'].value,
          'Email',
        )
        .subscribe(
          (cyclists) => {
            if (cyclists && cyclists.cyclists.length > 0) {
              this.userExists = true;
              this.cyclists = cyclists.cyclists;

              // this.selectUser(this.cyclists[0]);
            } else {
              this.cyclistService
                .searchCyclistsOnPOS(
                  this.partnerId,
                  'email',
                  this.UserForm.controls['Email'].value,
                )
                .subscribe(
                  (posCustomer) => {
                    if (posCustomer && posCustomer.cyclists.length > 0) {
                      this.userExists = true;
                      this.cyclists = posCustomer.cyclists;
                      // this.selectUser(this.cyclists[0]);
                    } else {
                      this.cyclists = null;
                    }
                  },
                  (err) => {
                    this.cyclists = null;
                  },
                );
            }
          },
          (err) => {
            this.cyclists = null;
          },
        );
    } else {
      this.cyclists = null;
    }
  }

  searchPhone(event) {
    if (this.UserForm.controls['PhoneNumber'].value.length >= 9) {
      this.userExists = false;
      // this.cyclists = [];
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId,
          0,
          20,
          this.UserForm.controls['PhoneNumber'].value,
        )
        .subscribe(
          (cyclists) => {
            if (cyclists && cyclists.cyclists.length > 0) {
              this.userExists = true;
              this.cyclists = cyclists.cyclists;
            } else {
              this.cyclistService
                .searchCyclistsOnPOS(
                  this.partnerId,
                  'phone',
                  this.UserForm.controls['PhoneNumber'].value,
                )
                .subscribe(
                  (posCustomer) => {
                    if (posCustomer && posCustomer.cyclists.length > 0) {
                      this.userExists = true;
                      this.cyclists = posCustomer.cyclists;
                    } else {
                      this.cyclists = [];
                      console.log(this.cyclists);
                      if (
                        this.UserForm.controls['PhoneNumber'].value.length < 9
                      ) {
                        this.cyclists = null;
                      } else {
                        if (this.cyclists && this.cyclists.length > 0) {
                          this.cyclists = JSON.parse(
                            JSON.stringify(this.cyclists),
                          );
                        } else {
                          this.cyclists = null;
                        }
                      }
                    }
                  },
                  (err) => {
                    this.cyclists = null;
                  },
                );
            }
          },
          (err) => {
            this.cyclists = null;
          },
        );
    } else {
      if (this.UserForm.controls['PhoneNumber'].value.length < 9) {
        this.cyclists = null;
      } else {
        this.cyclists = JSON.parse(JSON.stringify(this.cyclists));
      }
    }
  }

  checkPhoneNumber(event) {
    if (this.user && this.user.ID === undefined) {
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId,
          0,
          20,
          this.UserForm.controls['PhoneNumber'].value,
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
            var userWithInternational = this.cyclists
              .filter((x) => {
                return x.PhoneNumber.indexOf('+') > -1;
              })
              .pop();
            if (userWithInternational) {
              this.selectUser(userWithInternational);
            } else {
              this.selectUser(this.cyclists[0]);
            }
          } else {
            this.cyclistService
              .searchCyclistsOnPOS(
                this.partnerId,
                'phone',
                this.UserForm.controls['PhoneNumber'].value,
              )
              .subscribe((posCustomer) => {
                if (posCustomer && posCustomer.cyclists.length > 0) {
                  this.userExists = true;
                  this.cyclists = posCustomer.cyclists;
                  var userWithInternational = this.cyclists
                    .filter((x) => {
                      return x.PhoneNumber.indexOf('+') > -1;
                    })
                    .pop();
                  if (userWithInternational) {
                    this.selectUser(userWithInternational);
                  } else {
                    this.selectUser(this.cyclists[0]);
                  }
                } else {
                  this.cyclists = null;
                }
              });
          }
        });
    }
  }

  searchSurname(event) {
    if (
      this.UserForm.controls['Surname'].value.length > 0 &&
      this.user.ID === undefined &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId,
          0,
          50,
          this.UserForm.controls['Surname'].value,
          'LastName',
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
          } else {
            this.cyclistService
              .searchCyclistsOnPOS(
                this.partnerId,
                'surname',
                this.UserForm.controls['Surname'].value,
              )
              .subscribe((posCustomer) => {
                if (posCustomer && posCustomer.cyclists.length > 0) {
                  this.userExists = true;
                  this.cyclists = posCustomer.cyclists;
                } else {
                  this.cyclists = null;
                }
              });
          }
        });
    } else {
      this.cyclists = null;
    }
  }

  searchName(event) {
    if (
      this.UserForm.controls['Name'].value.length >= 3 &&
      this.user.ID === undefined &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.userExists = false;
      this.cyclistService
        .searchCyclistsV2(
          this.partnerId,
          0,
          50,
          this.UserForm.controls['Name'].value,
          'FirstName',
        )
        .subscribe((cyclists) => {
          if (cyclists && cyclists.cyclists.length > 0) {
            this.userExists = true;
            this.cyclists = cyclists.cyclists;
          } else {
            this.cyclistService
              .searchCyclistsOnPOS(
                this.partnerId,
                'name',
                this.UserForm.controls['Name'].value,
              )
              .subscribe((posCustomer) => {
                if (posCustomer && posCustomer.cyclists.length > 0) {
                  this.userExists = true;
                  this.cyclists = posCustomer.cyclists;
                } else {
                  this.cyclists = null;
                }
              });
          }
        });
    } else {
      this.cyclists = null;
    }
  }

  valid() {
    if (
      this.UserForm.controls['Email'].value ||
      this.UserForm.controls['PhoneNumber'].value
    ) {
      return true;
    }
  }

  saveUser(formData) {
    this.UserForm.controls['PartnerID'].setValue(this.partnerId);
    console.log(formData);
    if (this.user.ID) {
      this.createBike(formData, this.user);
    } else {
      this.createUser(formData);
    }
  }

  createUser(formData) {
    console.log('Creating user');
    let user = {
      ...formData,
      ...{
        Username: formData.Email ? formData.Email : formData.PhoneNumber,
        Password: this.appConfig.defaultUserPassword(),
        ConfirmPassword: this.appConfig.defaultUserPassword(),
        PartnerID: this.partnerId,
      },
    };
    this.busy = true;
    this.error = false;
    this.userService.createCustomer(user).subscribe(
      (newUser) => {
        //Set the users default unit of measure... need to change the registerUser API so we can pass this there...
        this.createBike(formData, newUser.Data);
        //this.cyclistService.getCyclistById(newUser.ID).subscribe((cyclist) => {
        //  cyclist.UnitsOfMeasureID = this.DefaultUnitOfMeasure;
        //  cyclist.PartnerID = this.partnerId;
        //  this.cyclistService.saveCyclist(cyclist).subscribe((user) => { });
        //});
        //this.partnerService
        //  .linkCyclistToPartner(this.partnerId, newUser.ID)
        //  .subscribe(
        //    (linked) => {
        //      console.log(linked);
        //      //if (formData.Manufacturer) {
        //      this.createBike(formData, newUser);
        //      // } else {
        //      //   if (this.update.observers.length > 0) {
        //      //     this.update.emit({ bike: {}, cyclist: user });
        //      //   } else {
        //      //     this.messageService.add({ life: 5000, detail: this.translate.instant('messages.cyclist_created') });
        //      //     this.modal.close();
        //      //   }
        //      // }
        //    },
        //    (error) => {
        //      this.busy = false;
        //    },
        //  );
      },
      (error) => {
        this.busy = false;
        this.errorMessage = this.translate.instant(
          'messages.problem_creating_cyclist',
        );
        this.error = true;
        this.confirmationService.confirm({
          message: this.translate.instant('messages.problem_creating_cyclist'),
          acceptLabel: this.translate.instant('general.ok'),
          rejectVisible: false,
        });
      },
    );
  }

  createBike(formData, user) {
    if (!formData.Manufacturer || formData.Manufacturer.length === 0) {
      formData.Manufacturer = this.translate.instant('general.walkin_bike');
    }

    this.busy = true;
    let bike = {
      ID: 0,
      UserID: user.ID,
      RefNo:
        formData.Manufacturer +
        (formData.Model && formData.Model.length > 0
          ? ' - ' + formData.Model
          : ''),
      SerialNo: formData.SerialNo,
      Manufacturer: formData.Manufacturer,
      Model: formData.Model || '',
      Colour: formData.Color || '',
      ModelYear: formData.Year || '',
      TypeID: formData.TypeID || 99,
      LastService: new Date(),
      DateBought: null,
      StatusID: 0,
      PartnerType: this.partnerData.PartnerType,
    };
    this.bikeService.saveBike(bike).subscribe(
      (newBike) => {
        this.busy = false;
        if (this.update.observers.length > 0) {
          this.update.emit({ bike: newBike, cyclist: user, next: true });
        } else {
          this.modal.close();
          this.messageService.add({
            life: 5000,
            detail: this.translate.instant('messages.cyclist_bike_created'),
          });
        }
      },
      (error) => {
        this.busy = false;
      },
    );
  }

  selectUser(user) {
    user = user.value || user;
    this.user = user;
    console.log(user);
    if (user.ID == 0) {
      this.cyclistService
        .linkCyclists(this.partnerId, user)
        .subscribe((linkedUser) => {
          user = linkedUser.Data[0];
          this.busy = false;
          this.user = linkedUser.Data[0];
          this.reloadControlData();
          this.busy = true;
          this.selectedBike = {};
          console.log(user);
          this.getActiveBikes(user);
          this.disableControls();
        });
    } else {
      this.user = user;
      this.reloadControlData();
      this.busy = true;
      this.selectedBike = {};
      this.getActiveBikes(user);
      this.disableControls();
    }
  }

  getActiveBikes(user) {
    this.cyclistService
      .getActiveBikesForCyclistAndPartner(user.ID, this.partnerData.ID)
      .subscribe(
        (bikes) => {
          this.busy = false;
          this.bikes = [];
          this.bikes.push({
            label: this.translate.instant(
              'bikeshop.modal.shedule_service.select_bike',
            ),
            value: {},
          });
          bikes.forEach((bike) => {
            this.bikes.push({
              label: bike.Manufacturer + ' ' + bike.Model,
              value: bike,
            });
          });

          var bike = this.bikes
            .filter((x) => {
              return x.value.ID === this.selectedBike.ID;
            })
            .pop();
          if (
            this.selectedBike &&
            this.selectedBike.ID &&
            bike &&
            bike.value &&
            bike.value.ID
          ) {
            this.addNewBike = false;
            this.update.emit({ cyclist: this.user, bike: this.selectedBike });
          } else if (this.bikes.length > 1) {
            this.selectedBike = this.bikes[1].value;
            this.addNewBike = false;
            this.update.emit({ cyclist: this.user, bike: this.selectedBike });
          }
        },
        (error) => {
          this.busy = false;
          this.bikes = [];
          this.addNewBike = true;
        },
      );
  }

  selectBike(bike) {
    this.addNewBike = false;
    this.update.emit({ cyclist: this.user, bike: this.selectedBike });
  }

  addBike() {
    this.addNewBike = true;
    this.selectedBike = {};
    this.update.emit({ cyclist: this.user, bike: this.selectedBike });
  }

  clearForm() {
    this.user = {};
    this.cyclists = null;
    this.selectedBike = {};
    this.bikes = [];
    this.addNewBike = false;
    this.enableControls();
    this.reloadControlData();
    this.update.emit({ cyclist: this.user, bike: this.selectedBike });
    this.showDropdown = false;
    this.initSearches();
  }

  showAddBike() {
    return (
      this.user.ID || (this.valid() && this.UserForm.controls['Name'].value)
    );
  }

  validateEmail() {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(this.user.Email).toLowerCase());
  }

  updateCyclist(event, type) {
    if (
      !this.busy &&
      (type === 'PhoneNumber' ||
        type === 'Name' ||
        type === 'Surname' ||
        type === 'DateOfBirth' ||
        (type === 'Email' && this.validateEmail()))
    ) {
      this.busy = true;
      this.cyclistService.getCyclistById(this.user.ID).subscribe(
        (result) => {
          var cyclist = { ...result };
          cyclist.PartnerID = this.partnerId;
          if (type === 'PhoneNumber') {
            cyclist.PhoneNumber = this.user.PhoneNumber;
          }
          if (type === 'Name') {
            cyclist.Name = this.user.Name;
          }
          if (type === 'Surname') {
            cyclist.Surname = this.user.Surname;
          }
          if (type === 'Email') {
            cyclist.Email = this.user.Email;
          }
          this.cyclistService.updateCyclist(cyclist).subscribe(
            (updatedCyclist) => {
              this.user = updatedCyclist;
              if (event !== null) {
                event.deactivate();
              }
              this.busy = false;
              this.messageService.add({
                life: 5000,
                detail: this.translate.instant(
                  'bikeshop.modal.update_job_card.job_card.cyclist_information_updated',
                ),
              });
            },
            (error) => {
              this.busy = false;
              this.messageService.add({
                life: 5000,
                detail: this.translate.instant('messages.error_updating_user'),
              });
            },
          );
        },
        (error) => {},
      );
    }
  }

  getBikeTypes() {
    this.gearService.getBikeTypes().subscribe((types) => {
      this.bikeTypes = types.map((x) => {
        return { value: x.id, label: this.translate.instant(x.label) };
      });
    });
  }

  getBikeType(typeID) {
    var type = this.bikeTypes
      .filter((x) => {
        return x.value === typeID;
      })
      .pop();
    if (type) {
      return type.label;
    } else {
      return '';
    }
  }

  setInputFocus(type) {
    this.inputFocus = type;
  }

  initSearches() {
    this.initPhoneSearch();
    this.initEmailSearch();
    this.initFirstNameSearch();
    this.initLastNameSearch();

    this.phoneResults = [];
    this.emailResults = [];
    this.firstNameResults = [];
    this.lastNameResults = [];
    this.newCustomer = false;
  }

  initPhoneSearch(): void {
    this.UserForm.controls['PhoneNumber'].valueChanges
      .pipe(
        debounceTime(1000), // Wait for user to stop typing
        distinctUntilChanged(), // Ignore consecutive duplicate queries
        switchMap((query: string) => {
          if (this.newCustomer) {
            this.phoneResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }

          if (!query || query.length <= 7) {
            this.phoneResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }
          if (!this.newCustomer) {
            this.isloading = true;
          }
          return this.cyclistService
            .searchCyclistsV2(this.partnerId, 0, 20, query, 'phone')
            .pipe(
              catchError(() => {
                this.isloading = false;
                return of(null); // Handle errors gracefully
              }),
              map((cyclists: any) => ({
                source: 'V2',
                data: cyclists,
                query,
              })),
            );
        }),
      )
      .subscribe((result: any) => {
        this.isloading = false;
        if (
          result &&
          result.source === 'V2' &&
          result.data?.cyclists?.length > 0
        ) {
          this.userExists = true;
          this.phoneResults = result.data.cyclists;
          this.newCustomer = false;
          this.showDropdown = true;
        } else {
          this.searchCyclistsOnPOS(
            this.UserForm.controls['PhoneNumber'].value,
            this.phoneResults,
            'phone',
            'PhoneNumber',
          );
        }
      });
  }

  initEmailSearch(): void {
    this.UserForm.controls['Email'].valueChanges
      .pipe(
        debounceTime(1000), // Wait for user to stop typing
        distinctUntilChanged(), // Ignore consecutive duplicate queries
        switchMap((query: string) => {
          if (this.newCustomer) {
            this.emailResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }

          if (!query || query.length < 3) {
            this.emailResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }
          if (!this.newCustomer) {
            this.isloading = true;
          }
          return this.cyclistService
            .searchCyclistsV2(this.partnerId, 0, 20, query, 'Email')
            .pipe(
              catchError(() => {
                this.isloading = false;
                return of(null); // Handle errors gracefully
              }),
              map((cyclists: any) => ({
                source: 'V2',
                data: cyclists,
                query,
              })),
            );
        }),
      )
      .subscribe((result: any) => {
        this.isloading = false;
        if (
          result &&
          result.source === 'V2' &&
          result.data?.cyclists?.length > 0
        ) {
          this.userExists = true;
          this.emailResults = result.data.cyclists;
          this.newCustomer = false;
          this.showDropdown = true;
        } else {
          this.searchCyclistsOnPOS(
            this.UserForm.controls['Email'].value,
            this.emailResults,
            'email',
            'Email',
          );
        }
      });
  }

  initFirstNameSearch(): void {
    this.UserForm.controls['Name'].valueChanges
      .pipe(
        debounceTime(1000), // Wait for user to stop typing
        distinctUntilChanged(), // Ignore consecutive duplicate queries
        switchMap((query: string) => {
          this.checkNewCustomerInput();
          if (this.newCustomer) {
            this.firstNameResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }

          if (!query || query.length < 3) {
            this.firstNameResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }
          if (!this.newCustomer) {
            this.isloading = true;
          }
          return this.cyclistService
            .searchCyclistsV2(this.partnerId, 0, 20, query)
            .pipe(
              catchError(() => {
                this.isloading = false;
                return of(null); // Handle errors gracefully
              }),
              map((cyclists: any) => ({
                source: 'V2',
                data: cyclists,
                query,
              })),
            );
        }),
      )
      .subscribe((result: any) => {
        this.isloading = false;
        if (
          result &&
          result.source === 'V2' &&
          result.data?.cyclists?.length > 0
        ) {
          this.userExists = true;
          this.firstNameResults = result.data.cyclists;
          this.newCustomer = false;
          this.showDropdown = true;
        } else {
          this.searchCyclistsOnPOS(
            this.UserForm.controls['Name'].value,
            this.firstNameResults,
            'name',
            'Name',
          );
        }
      });
  }

  initLastNameSearch(): void {
    this.UserForm.controls['Surname'].valueChanges
      .pipe(
        debounceTime(1000), // Wait for user to stop typing
        distinctUntilChanged(), // Ignore consecutive duplicate queries
        switchMap((query: string) => {
          if (this.newCustomer) {
            this.lastNameResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }
          if (!query || query.length < 3) {
            this.lastNameResults = [];
            this.showDropdown = false;
            this.isloading = false;
            return of(null); // Return empty observable for invalid queries
          }
          if (!this.newCustomer) {
            this.isloading = true;
          }

          return this.cyclistService
            .searchCyclistsV2(this.partnerId, 0, 20, query, 'LastName')
            .pipe(
              catchError(() => {
                this.isloading = false;
                return of(null); // Handle errors gracefully
              }),
              map((cyclists: any) => ({
                source: 'V2',
                data: cyclists,
                query,
              })),
            );
        }),
      )
      .subscribe((result: any) => {
        this.isloading = false;
        if (
          result &&
          result.source === 'V2' &&
          result.data?.cyclists?.length > 0
        ) {
          this.userExists = true;
          this.lastNameResults = result.data.cyclists;
          this.newCustomer = false;
          this.showDropdown = true;
        } else {
          this.searchCyclistsOnPOS(
            this.UserForm.controls['Surname'].value,
            this.lastNameResults,
            'surname',
            'Surname',
          );
        }
      });
  }

  searchCyclistsOnPOS(query: string, restultArray, type, formControl): void {
    restultArray = [];

    if (type != 'phone' && (!query || query.length < 4)) {
      this.checkNewCustomerInput();
      return;
    }

    if (type == 'phone' && (!query || query.length <= 7)) {
      this.checkNewCustomerInput();
      return;
    }

    if (!this.newCustomer) {
      this.isloading = true;
    }
    this.showDropdown = false;
    this.cyclistService
      .searchCyclistsOnPOS(this.partnerId, type, query)
      .pipe(
        catchError(() => of(null)),
        map((posCustomer: any) => ({
          source: 'POS',
          data: posCustomer,
          query,
        })),
      )
      .subscribe((result: any) => {
        if (!this.newCustomer) {
          this.isloading = true;
        }
        if (
          result &&
          result.source === 'POS' &&
          result.query === this.UserForm.controls[formControl].value
        ) {
          if (result.data?.cyclists?.length > 0) {
            this.isloading = false;
            this.userExists = true;
            restultArray = result.data.cyclists;
            this.newCustomer = false;
            this.showDropdown = true;
          } else {
            restultArray = [];
            if (this.checkNewCustomerInput()) {
              this.newCustomer = true;
            }

            this.showDropdown = false;
            this.isloading = false;
          }
        }
      });
  }

  removeDropdown(type: string) {
    this.inputFocus = '';
  }

  checkNewCustomerInput() {
    if (
      !this.UserForm.controls['Surname'].value &&
      !this.UserForm.controls['Name'].value &&
      !this.UserForm.controls['Email'].value &&
      !this.UserForm.controls['PhoneNumber'].value
    ) {
      this.initSearches();
      return false;
    }
    return true;
  }
}
